<template>
  <div class="account-set-layout">
    <Header type='home-header' />
    <el-row class="tac">
      <el-col :span="4" class="menu-el-col">
        <h5 class="panel-wrap" @click="toggleShowMenu">{{$t('account_set_menu')}}</h5>
        <el-menu
          class="bonus-menu"
          background-color="#0A0E22"
          text-color="#989AA2"
          active-text-color="#fff"
          :default-openeds="defaultOption"
          router="router"
        >
          <!-- 节点提交 -->
          <el-submenu
            v-if="isZnWebsite"
            index="1"
            class="revenue-wrap"
          >
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img
                  class="menu-icon home-icon total-revenue-icon"
                  src="../../assets/menu/node.png"
                >
                <span>节点提交</span>
              </div>
            </template>
            <el-menu-item-group :span="3">
              <!-- 标准节点提交 -->
              <el-menu-item
                index="1-1"
                route="/standardNode"
                v-bind:class="{ isActive: (thisPath === '/standardNode') }"
              >
                标准节点提交
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 节点列表 -->
          <el-submenu
            index="2"
            class="revenue-wrap"
          >
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img
                  class="menu-icon home-icon total-revenue-icon"
                  src="../../assets/accountSet/hard-list.png"
                >
                <span>{{ $t('node_list') }}</span>
              </div>
            </template>
            <el-menu-item-group :span="3">
              <!-- 标准节点 -->
              <el-menu-item
                index="2-1"
                route="/hardList"
                v-bind:class="{ isActive: (thisPath === '/hardList') }"
              >
                {{ $t('lite_node') }}
              </el-menu-item>
              <!-- 标准节点 -->
              <el-menu-item
                v-if="isZnWebsite"
                index="2-1"
                route="/standardList"
                v-bind:class="{ isActive: (thisPath === '/standardList') }"
              >
                标准节点
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 软路由 -->
          <el-submenu
            v-if="isZnWebsite"
            index="3"
            class="revenue-wrap"
          >
            <template slot="title">
              <div v-bind:class="{ revenuePad: true }">
                <img
                  class="menu-icon home-icon total-revenue-icon"
                  src="../../assets/menu/route.png"
                >
                <span>软路由</span>
              </div>
            </template>
            <el-menu-item-group :span="3">
              <el-menu-item
                index="3-1"
                route="/dialConfig"
                v-bind:class="{ isActive: (thisPath === '/dialConfig') }"
              >
                汇聚拨号配置
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-col>
      <el-col
        :span="20"
        class="bonus-content"
      >
        <div class="title">
          <img
            class="title-img"
            src="../../assets/accountSet/hardwareBlack.png"
          />
          {{layoutTitile}}
        </div>
        <slot></slot>
      </el-col>
    </el-row>
    <Footer />
  </div>
</template>

<i18n>
{
  "en": {
    "account_set_menu": "Account Settings",
    "account_set_1": "Hardware List",
    "node_list": "Node List",
    "lite_node": "Lite Node"
  },
  "zn": {
    "account_set_menu": "硬件列表",
    "account_set_1": "硬件列表",
    "node_list": "节点列表",
    "lite_node": "轻节点"
  }
}
</i18n>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Common/Footer.vue";
import { mapState, mapActions } from "vuex";
import { getCookie } from "@/utils/utils";

export default {
  name: "AccountSetLayout",
  components: {
    Header,
    Footer
  },
  props: {
    layoutType: "",
    layoutTitile: ""
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
    thisPath() {
      return this.$route.path;
    },
    defaultOption() {
      let thisPath = this.$route.path;
      if (["/standardNode"].includes(thisPath)) {
        return ["1"];
      } else if (["/hardList", "/standardList"].includes(thisPath)) {
        return ["2"];
      } else if (["/dialConfig"].includes(thisPath)) {
        return ["3"];
      }
    }
  }),
  methods: {
    toggleShowMenu () {
      this.showMenu = !this.showMenu
      const body = document.getElementsByTagName('body')[0]
      if (this.showMenu) {
        body.classList.add('overflow-hidden')
      } else {
        body.classList.remove('overflow-hidden')
      }
    },
   }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.isActive, .el-menu-item.is-active {
  background-color: #032031;
  border-left: 3px solid #11B6BD;
  color: #fff !important;
}

.account-set-layout, .tac {
  height: 100%;
}

.is-mobile .menu-el-col .el-col-4{
  width: 100% !important;
}
</style>
